import { selectDeviceInfo, selectDeviceType } from 'features/application/applicationSlice';
import { call, select } from 'redux-saga/effects';
import UAParser from 'ua-parser-js';
import { logger } from 'utils/logger';

type BrandVersion = { brand: string; version: string };

type UserAgentData = {
  getHighEntropyValues: (hints: string[]) => Promise<{ fullVersionList?: BrandVersion[] }>;
};

// UA-CH only: Firefox and Safari expose no userAgentData, and their UA string already carries the build.
export const readBrowserBuild = async (): Promise<string | null> => {
  const { userAgentData } = navigator as { userAgentData?: UserAgentData };

  if (!userAgentData) {
    return null;
  }

  try {
    const { fullVersionList } = await userAgentData.getHighEntropyValues(['fullVersionList']);

    if (!fullVersionList?.length) {
      return null;
    }

    return fullVersionList.map(({ brand, version }) => `${brand}/${version}`).join(', ');
  } catch {
    return null;
  }
};

export function* logEnvSaga() {
  const deviceInfo: UAParser.IResult = yield select(selectDeviceInfo);
  const deviceType: string = yield select(selectDeviceType);
  if (deviceInfo) {
    logger
      .remote()
      .info(
        `Browser: ${deviceInfo.browser.name} ${deviceInfo.browser.version}, ${deviceInfo.os.name}. Platform: ${deviceType}, ${window.innerWidth}x${window.innerHeight}`
      );
  }

  const browserBuild: string | null = yield call(readBrowserBuild);
  if (browserBuild) {
    logger.remote().info(`Browser build: ${browserBuild}`);
  }
}
